import { alpha, createTheme } from "@mui/material/styles"

/**
 * Portfolio theme. Pattern copied from SuperAdmin moog-patch-maker + HeyJoe
 * ThemeProvider / createTheme basics. Navy plate, electric blue (not purple).
 */
const navy = "#070b14"
const plate = "#0f1726"
const plateElevated = "#162235"
const blue = "#007fff"
const blueLight = "#4da6ff"
const ink = "#e8eefc"
const border = alpha("#ffffff", 0.1)

export const portfolioTheme = createTheme({
  cssVariables: true,
  palette: {
    mode: "dark",
    primary: { main: blue, light: blueLight, dark: "#0060c2", contrastText: "#041018" },
    secondary: { main: "#7eb6f5" },
    background: { default: navy, paper: plate },
    text: { primary: ink, secondary: alpha(ink, 0.68) },
    divider: border,
  },
  typography: {
    fontFamily: '"DM Sans", system-ui, sans-serif',
    h1: {
      fontFamily: '"Instrument Serif", Georgia, serif',
      fontWeight: 400,
      letterSpacing: "-0.02em",
      lineHeight: 1.05,
    },
    h2: {
      fontFamily: '"Instrument Serif", Georgia, serif',
      fontWeight: 400,
      letterSpacing: "-0.01em",
    },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          minHeight: "100vh",
          backgroundImage: `radial-gradient(ellipse 70% 45% at 50% -15%, ${alpha(blue, 0.18)}, transparent),
            radial-gradient(ellipse 50% 35% at 100% 100%, ${alpha(blueLight, 0.08)}, transparent)`,
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 999, fontWeight: 700 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: alpha(plateElevated, 0.9),
          border: `1px solid ${border}`,
        },
      },
    },
  },
})
